import script from "./EditChatTitleDialogue.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditChatTitleDialogue.vue?vue&type=script&setup=true&lang=ts"

import "./EditChatTitleDialogue.vue?vue&type=style&index=0&id=4ea76a9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea76a9e"]])

export default __exports__